<script lang="ts" setup>
import PricesUnlimNew from "~/components/sx/prices/PricesUnlimNew.vue";
import IconPriceTraffic from "~/components/sx/icons/prices/IconPriceTraffic.vue";
import IconPriceUnlim from "~/components/sx/icons/prices/IconPriceUnlim.vue";
import PricesTraffic from "~/components/sx/prices/PricesTraffic.vue";

const { t } = useI18n();

const text = computed(() => {
  return {
    traffic: {
      title: t('pages.home.prices.traffic.title'),
      description: t('pages.home.prices.traffic.description'),
    },
    unlim: {
      title: t('pages.home.prices.unlim.title'),
      description: t('pages.home.prices.unlim.description'),
    },
  }
})
</script>

<template>
  <section class="sx-prices">
    <h2 class="sx-landing-title white sx-prices__title">
      {{ $t('pages.home.prices.title') }}
    </h2>

    <div class="sx-prices__wrapper">
      <div class="sx-prices__content">
        <div class="sx-prices__header">
          <IconPriceUnlim />
          <div class="sx-prices__header-text">
            <h3 class="sx-prices__subtitle">
              {{ text.unlim.title }}
            </h3>
            <p class="sx-prices__description">
              {{ text.unlim.description }}
            </p>
          </div>
        </div>
        <prices-unlim-new />
      </div>

      <div class="sx-prices__content">
        <div class="sx-prices__header">
          <IconPriceTraffic />
          <div class="sx-prices__header-text">
            <h3 class="sx-prices__subtitle">
              {{ text.traffic.title }}
            </h3>
            <p class="sx-prices__description">
              {{ text.traffic.description }}
            </p>
          </div>
        </div>
        <PricesTraffic />
      </div>
    </div>

    <div class="sx-prices__video">
      <client-only>
        <lazy-sx-video-lines loop />
      </client-only>
    </div>
    <div class="blur" />
  </section>
</template>

<style lang="scss" scoped>
.blur {
  background: linear-gradient(180deg,rgb(0, 0, 0, 0) 0%, rgb(0, 0, 0, 0.3) 20%,rgb(0, 0, 0, 0.5) 30%,  rgb(0, 0, 0, 0.7) 40%, rgb(0, 0, 0, 0.75) 50%, rgba(0, 0, 0, 0.8) 60%, rgba(0, 0, 0, 9.5) 70%);
  position: absolute;
  bottom: 0;
  z-index: 1;
  height: 100%;
  width: 100%;
}

.sx-prices {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #000000;
  color: #fff;
  padding: 4rem 0;
  position: relative;

  @media (width < 1040px) {
    height: auto;
  }
  @media (height < 860px) {
    height: auto;
  }
  @media (width < 600px) {
    padding: 32px 0;
  }

  &__header {
    display: flex;
    align-items: flex-start;
    gap: 24px;
    @media (width < 767px) {
      gap: 1rem;
      flex-direction: column;
    }
  }
  &__header-text {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 780px;
  }
  &__subtitle {
    font-weight: 700;
    font-size: 40px;
    line-height: 40px;
    @media (width < 767px) {
      font-size: 28px;
      line-height: 32px;
    }
  }
  &__description {
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    @media (width < 767px) {
      font-size: 16px;
      line-height: 20px;
    }
  }
  &__video {
    right: 0;
    bottom: 0;
    min-width: 100%;
    position: absolute;
    z-index: 2;

    @media (height < 1000px) {
      bottom: -13%;
    }
    @media (width < 600px) {
      bottom: -60%;
    }
  }
  &__img {
    right: 0;
    bottom: 0;
    min-width: 100%;
    position: absolute;
    z-index: 2;
    img {
      width: 100%;
      display: block;
    }
  }
  &__title {
    margin-bottom: 40px;
    font-weight: 400;
    @media (width < 767px) {
      margin-bottom: 16px;
      min-height: auto;
    }
  }
  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: 48px;
    max-width: 1264px;
    padding-inline: 2rem;
    min-height: 640px;
    width: 100%;
    z-index: 9999;
  }
  &__content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 32px;
    border: var(--border-sx-main-opacity);
    border-radius: 36px;
    @media (max-width: 767px) {
      padding: 1rem;
    }
  }
  &__void {
    height: 300px;
  }
}
</style>
